import { Box } from 'grommet'
import Plot from 'react-plotly.js'

function Plotter(props) {
    var data = props.data
  return (
    <Box justify='center' align='center' pad='xsmall'>
        <h2>Diagramas</h2>
        {data.x.map((item,i) => {
            return(
                <Box justify='center' align='center' pad='xsmall'>
                    <h3>Barra {i+1}</h3>
                    <Plot
                        data={[{
                        x: item,
                        y: data.ynormal[i],
                        type: 'scatter',
                        mode: 'lines'
                        }]}
                        layout={ {width: "5%", height: "5%", title: `Normal na barra ${i+1} (kN.m)`} }
                    />
                    <Plot
                        data={[{
                        x: item,
                        y: data.yshear[i],
                        type: 'scatter',
                        mode: 'lines'
                        }]}
                        layout={ {width: "5%", height: "5%", title: `Cortante na barra ${i+1} (kN.m)`} }
                    />
                    <Plot
                        data={[{
                        x: item,
                        y: data.ymoment[i],
                        type: 'scatter',
                        mode: 'lines'
                        }]}
                        layout={ {width: "5%", height: "5%", title: `Momento na barra ${i+1} (kN.m)`, yaxis: {autorange: 'reversed'}} }
                    />
                </Box>
            )
        })}
    </Box>
  )
}

export default Plotter